import { render, staticRenderFns } from "./warehouseStock.vue?vue&type=template&id=1dcf08b6&scoped=true"
import script from "./warehouseStock.vue?vue&type=script&lang=js"
export * from "./warehouseStock.vue?vue&type=script&lang=js"
import style0 from "./warehouseStock.vue?vue&type=style&index=0&id=1dcf08b6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcf08b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dcf08b6')) {
      api.createRecord('1dcf08b6', component.options)
    } else {
      api.reload('1dcf08b6', component.options)
    }
    module.hot.accept("./warehouseStock.vue?vue&type=template&id=1dcf08b6&scoped=true", function () {
      api.rerender('1dcf08b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/logisticsSystem/warehouseManagement/warehouseStock/warehouseStock.vue"
export default component.exports